import { connect } from 'react-redux';
import * as actions from '../../actions/structure';
import Structure from '../../components/structure/Structure';

const mapStateToProps = ({ structure }) => ({
  structure: [{name: 'Командование института', children: structure.structure}],
  isLoading: structure.isLoading,
});

const mapDispatchToProps = dispatch => ({
  didMount: () => dispatch(actions.structure()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Structure);
